export const SCROLL_DEBOUNCE_MS = 200;

export const MOBILE_MAX_HEADER_ITEMS = 4;

// Regular (non-widget) primary-header fields that belong on the identity line rather than the
// metrics line. Milestone status ('status') sits here too but is promoted to the status widget.
export const IDENTITY_FIELD_NAMES = ['borrower'];

export const AUS_POPPER_Z_INDEX_OFFSET = 100;

export const popperModifiers = [
  {
    name: 'preventOverflow',
    options: {
      altAxis: true,
      tether: false,
      padding: 8,
    },
  },
  {
    name: 'flip',
    options: {
      fallbackPlacements: ['bottom-start', 'top-end', 'top-start'],
      padding: 8,
    },
  },
];
